import { docValidations } from "./docValidation";

const global = {
  complete: `Complete`,
  address: `Address`,
  email: `Email`,
  accepted: `Accepted`,
  not_accepted: `Not accepted`,
  individual_information: `Individual information`,
  full_name: `Full name`,
  nationality: `Nationality`,
  document: `Document`,
  terms_and_conditions: `Terms and Conditions`,
  updated_by: `Updated by`,
  updated_on: `Updated on`,
  last_updated: `Last updated`,
  last_updated_by: `Last updated by {{updatedBy}} on {{lastUpdated}}`,
  last_created_by: `Created by {{createdBy}} on {{createdOn}}`,
  last_updated_on: `Last updated: {{lastUpdated}}`,
  last_deleted_by: `Last deleted by {{deletedBy}} on {{deletedOn}}`,
  connecting: `Connecting`,
  today: `Today`,
  load_more: `Load more`,
  download_csv: `Download CSV`,
  end_of_result: `End of result`,
  recipient: `Recipient`,
  note: `Note`,
  total_balance: `Total balance`,
  file_name: `File name`,
  account: `Account`,
  view_history: `View history`,
  view_change_logs: `View change logs`,
  company_id: `Company ID`,
  include_onboarded_users: `Include onboarded users`,
  show_onboarded_customers: `Show onboarded customers`,
  show_onboarded_suppliers: `Show onboarded suppliers`,
  disconnect: `Disconnect`,
  configure: `Configure`,
  in_process: `In process`,
  documents: `Documents`,
  connect: `Connect`,
  continue: `Continue`,
  compliance: `Compliance`,
  PartialPaid: `Partial paid`,
  create: `Create`,
  "Preview only – not compliant for official use.": `Preview only – not compliant for official use.`,
  bic: `Swift code / Bank information code`,
  debitorAccountHolderName: `Debitor account holder name`,
  debitorIBAN: `Debitor IBAN`,
  exportedBy: `Exported by`,
  characters: `Characters`,
  "Export Payment Template": `Export Payment Template`,
  transactionId: `Transaction Id`,
  transactionStatus: `Transaction status`,
  createdBy: `Created by`,
  templateId: `Template Id`,
  destination: `Destination`,
  supported_documents: `Supported documents`,
  no_supported_documents_found: `No supported documents found`,
  expiry_date: `Expiry date`,
  document_name_is_required: `Document name is required`,
  documents_uploaded_successfully: `{{count}} documents uploaded successfully`,
  documents_upload_failed: `{{count}} documents failed to upload`,
  delete_document: `Delete document`,
  this_action_cannot_be_undone: `This action cannot be undone`,
  unsaved_changes: `Unsaved changes`,
  unsaved_changes_warning: `You have unsaved changes. Are you sure you want to continue?`,
  discard_and_continue: `Discard and continue`,
  document_upload_failed: `Document upload failed`,
  upload_support_document: `Upload Support Document`,
  upload_supplier_support_document: `Upload supplier support document`,
  add_expiry_date: `Add expiry date`,
  document_expires_on: `Expires on {{expiryDate}}`,
  document_expired_on: `Expired on {{expiryDate}}`,
  expiry_date_cannot_be_in_the_past: `Expiry date cannot be in the past`,
  document_updated_successfully: `Document uploaded successfully`,
  upload_your_document: `Upload your document`,
  drag_and_drop_your_files_here: `Drag and drop your files here`,
  browse_files: `Browse files`,
  files_accepted_only: `{{acceptedFiles}} files accepted only`,
  upload_and_manage_support_documents: `Upload and manage support documents`,
  save_document: `Save document`,
  set_document_expiry: `Set document expiry`,
  upload_new: `Upload new`,
  expiry_date_is_required: `Expiry date is required`,
  update_document: `Update document`,
  expiry_date_cannot_be_less_than_current_date: `Expiry date cannot be earlier than the current date`,
  bank_accounts: `Bank Accounts`,
  yesterday: "Yesterday",
  this_week: "This week",
  last_week: "Last week",
  this_month: "This month",
  last_month: "Last month",
  this_quarter: "This quarter",
  last_quarter: "Last quarter",
  this_year: "This year",
  last_year: "Last year",
  custom: "Custom",

  receivables: `Receivables`,
  sales_invoices: `Sales Invoices`,
  sales_orders: `Sales Orders`,
  sales_delivery_note: `Sales Delivery Note`,
  "sales-invoices": `Sales Invoices`,
  "sale-invoice": `Sales Invoices`,
  email_documents_to_dost_portal: `Email documents to Dost portal`,
  scan_with_Dost_Upload_App: `Scan with Dost Upload App`,
  upload_via_qr_code: `Upload via QR Code`,
  png_pdf_jpeg: `PNG, PDF, JPEG`,
  receive_via_customer_portal: `Receive via Customer Portal`,
  customer_uploads_directly_in_customer_portal: `Customer uploads directly in Customer Portal`,
  receive_via_supplier_portal: `Receive via Supplier Portal`,
  supplier_uploads_directly_in_supplier_portal: `Supplier uploads directly in Supplier Portal`,
  view_received_emails: `View Received Emails`,
  Receive: `Receive`,
  Create: `Create`,
  "Verifactu - Regular Invoice": `Verifactu - Regular Invoice`,
  "Verifactu - Simplified Invoice": `Verifactu - Simplified Invoice`,
  "SDI - Regular Invoice": `SDI - Regular Invoice`,
  "SII - Regular Invoice": `SII - Regular Invoice`,
  "SII - Simplified Invoice": `SII - Simplified Invoice`,
  "Sale Delivery Note": `Sale Delivery Note`,
  "Purchase Order": `Purchase Order`,
  "PA(France) - Regular Invoice": `PA(France) - Regular Invoice`,
  sync_documents_from_email_and_other_connected_datasources: `Sync Documents from Email and Other Connected Data Sources`,
  view_existing_drafts: `View Existing Drafts`,
  "sale-order": `Sales Orders`,
  "sale-delivery-note": `Sales Delivery Note`,
  payables: `Payables`,
  dimensions: `Dimensions`,
  purchase_invoices: `Purchase Invoices`,
  purchase_orders: `Purchase Orders`,
  purchase_delivery_note: `Purchase Delivery Notes`,
  "purchase-invoice": `Purchase Invoices`,
  "purchase-order": `Purchase Orders`,
  "purchase-deliverynote": `Purchase Delivery Note`,
  doc_date: `Document date`,
  customer: `Customer`,
  invoice_no: `Invoice No.`,
  protocol: `Protocol`,
  doc_status: `Document status`,
  erp_status: `ERP Status`,
  RegularInvoice: `Regular Invoice`,
  SimplifiedInvoice: `Simplified Invoice`,
  CreditNote: `Credit Note`,
  DebitNote: `Debit Note`,
  CorrectiveInvoice: `Corrective Invoice`,
  CancelInvoice: `Cancel Invoice`,
  ReplacementInvoice: `Replacement Invoice`,
  delivery_note_number: `Delivery Note No.`,
  purchase_order_number: `Purchase Order No.`,
  sale_order_number: ` Sale Order No.`,
  not_found: `Not found`,
  vendor: `Vendor`,
  integrated: `Integrated`,
  not_integrated: `Not Integrated`,
  documentClass_drafts: `{{documentClass}} Drafts`,
  drafts: `Drafts`,
  actions: `Actions`,
  no_compliance_standard_found: `No compliance standard found`,
  save_as_draft: `Save as draft`,
  draft_delete_title: `Are you sure you want to delete this draft?`,
  draft_delete_warning: `This action cannot be undone. The draft will be permanently deleted.`,
  document_draft_saved_successfully: `Document draft saved successfully`,
  draft_deleted_successfully: `Draft deleted successfully`,
  failed_to_delete_draft: `Failed to delete draft`,
  ...docValidations,
  FrancePA: `PA(France)`,
  FrancePA_document: `PA(France) Document`,
  france_regular_invoice: `PA(France) Regular Invoice`,
  companies: `Companies`,
  selftrainginProject: `Self training project`,
  selftrainginMatchingTag: `Self training matching tag`,
  export: `Export`,
  pay_invoices: `Pay Invoices`,
  unclassified_documents: `Unclassified documents`,
  unclassified: `Unclassified`,
  discard: `Discard`,
  confirm_mapping_upload_text: `Are you sure you want to remove previous mapping?`,
  confirm_mapping_upload_subtitle: `All of your existing mappings will be deleted and will not be used to map values to connected fields in future`,
  send_pa_status: `Send PA status`,
  send_pa_status_subtitle: `Manage status of your France(PA) invoice`,
  rejection_reason: `Rejection Reason`,
  pa_status_sent_successfully: `PA status sent successfully`,
  status_is_required: `Status is required`,
  total_enabled: `{{selected}} of {{total}} Enabled`,
  chart: `Chart`,
  delete_chart: `Delete chart`,
  category: `Category`,
  delete_visualization: `Delete visualization`,
  delete_visualization_confirmation: `Are you sure you want to delete this visualization?`,
  delete_role: `Delete role`,
  delete_this_field: `Delete this field`,
  SystemAdmin_role_cannot_be_combined_with_other_roles: `SystemAdmin role cannot be combined with other roles`,
  create_role: `Create Role`,
  edit_role: `Edit Role`,
  role_name: `Role Name`,
  enter_role_name: `Enter Role Name`,
  create_new_role_and_assign_it_module_wise_permissions: `Create new role and assign it module wise permissions`,
  all_modules: `All Modules`,
  filter_roles_by_name: `Filter roles by name`,
  out_permissions_enabled: `{{selected}} out {{total}} Permissions Enabled`,
  search_modules: `Search`,
  accept: `Accept`,
  is_signed: `Is signed`,
  OrganizationName_allowed_letters_numbers_and_spaces: `Organization name can only contain letters, numbers, and spaces`,
  OrganizationSector_allowed_letters_numbers_and_spaces: `Organization sector can only contain letters, numbers, and spaces`,
  webhook_configuration: `Webhook configuration`,
  webhook_events: `Webhook events`,
  acknowledge_invoice: `Acknowledge invoice`,
  acknowledge: `Acknowledge`,
  isAgreed: `Is Agreed`,
  acknowledgedBy: `Acknowledged by`,
  Note: `Note`,
  ack_ap_invoice_report: `Acknowledge AP Invoice Report`,
  acknowledged: `Acknowledged - {{status}}`,
  // Procurement
  purchase_requisitions: `Purchase requisitions`,
  "purchase-requisition":`Purchase Requisitions`,
  create_purchase_requisition: `Create Purchase Requisition`,
  procurement: `Procurement`,
  grn: `Goods Received Note`,
  grn_number: `GRN Number`,
  grn_delivery_reference: `GRN Delivery Reference`,
  requester: `Requester`,
  department: `Department`,
  updated_date: `Update date`,
  purchase_requisition_drafts: `Purchase requisition drafts`,
  purchase_requisition_deleted_successfully: `Requisition deleted successfully`,
  cannot_delete_posted_requisition: `Cannot delete posted requisition`,
  delete_purchase_requisition_confirmation: `Are you sure you want to delete this purchase requisition?`,
  vendor_information_is_required: `Vendor information is required`,
  purchase_requisition_is_being_processing: `Purchase requisition is being processed`,
  copy_email: `Copy email`,
  filter_by_property: `Filer by property`,
  filter_by_value: `Filter by value`,
  filter_by_description_or_value: `Filter by description or value`,
  save_as_default: `Save as Default`,
  select_a_property: `Select a property`,
  type_to_search_value: `Type to search value..`,
  add_filter: `Add filter`,
  finalize: `Finalize`,
  finalized: `Finalized`,
  finalized_successfully: `Finalized successfully`,
  finalize_purchase_requisition_confirmation: `Are you sure you want to finalize this purchase requisition? Once finalized, it cannot be edited or deleted.`,
  purchase_requisition_already_finalized:
    "Purchase Requisition is already finalized.",
  configuration_already_set: `Configuration already set`,
  docconfig_not_save: `Document configuration not saved`,
  finalize_purchase_order_confirmation: `Are you sure you want to finalize this purchase order? Once finalized, it cannot be edited or deleted.`,
  post: `Post`,
  posted: `Posted`,
  draft: `Draft`,
  submitted: `Submitted`,
  discarded: `Discarded`,
  posted_successfully: `Posted successfully`,
  post_purchase_requisition_confirmation: `Are you sure you want to post this purchase requisition? Once posted, it cannot be edited or deleted.`,
  post_purchase_order_confirmation: `Are you sure you want to post this purchase order? Once posted, it cannot be edited or deleted.`,
  create_po_from_pr: `Create PO from PR`,
  additional_field_is_required: `Additional field {{field}} is required`,
  purchase_order_drafts: `Purchase Order Drafts`,
  purchase_order_id: `Purchase Order ID`,
  vendor_company_name: `Vendor Company Name`,
  created_date: `Created Date`,
  permission_denied: `Permission denied`,
  "Purchase Order is already finalized.":
    "Purchase Order is already finalized.",
  logo_url_invalid:
    "Logo URL must be a valid image type (jpg, jpeg, png, gif).",
  document_number_required: "Document Number is required.",
  document_date_invalid:
    "Document Date must be a valid date and not the default minimum date.",
  customer_company_name_required: "Customer Company Name is required.",
  customer_company_id_required: "Customer Company ID is required.",
  customer_email_required: "Customer Email is required.",
  vendor_company_name_required: "Vendor Company Name is required.",
  vendor_email_required: "Vendor Email is required.",
  vendor_company_id_required: "Vendor Company ID is required.",
  vendor_customer_company_id_same:
    "'Vendor Company ID' and 'Customer Company ID' cannot be the same.",
  vendor_customer_email_same:
    "'Vendor Email' and 'Customer Email' cannot be the same.",
  vendor_customer_company_name_same:
    "'Vendor Company Name' and 'Customer Company Name' cannot be the same.",
  vendor_customer_company_address_same:
    "'Vendor Company Address' and 'Customer Company Address' cannot be the same.",
  currency_required: "Currency is required.",
  total_without_tax_invalid: "Total Without Tax must be greater than 0.",
  items_required: "At least 1 item is required.",
  vat_tax_conflict:
    "VAT Tax information must be provided either in the Tax Table or with the items, but not both.",
  tax_type_required: "Tax type is required in the Tax Table.",
  discount_conflict:
    "Discount information must be provided either in the 'Total Discount' field or with the items, but not both.",
  uploaded_document_invalid_type: "Only PDF or image file is allowed.",
  item_reference_code_required: "Reference Code of the item is mandatory.",
  item_description_required: "Description of the item is mandatory.",
  item_quantity_invalid:
    "Item's Quantity (with ReferenceCode and Description) must be greater than 0.",
  item_unit_price_invalid:
    "Item's UnitPrice (with ReferenceCode and Description) must be greater than 0.",
  item_tax_type_invalid:
    "Item's TaxType (with ReferenceCode and Description) cannot be 'WHT' or 'IRPF'. It should be defined in Taxes table.",
  purchase_requisition_number: `Purchase Requisition Number`,
  edit_document:`Edit document`,
  created_in_dost: `Created in Dost`,
  // role & sub user deletion blocked by workflow usage
  role_has_pending_workflow_tasks: `Role cannot be deleted because it has pending workflow task(s)`,
  role_used_in_active_workflow_templates: `Role cannot be deleted because it is used in active workflow template(s)`,
  user_has_pending_workflow_tasks: `User cannot be deleted because they have pending workflow task(s)`,
  user_used_in_active_workflow_templates: `User cannot be deleted because they are assigned in active workflow template(s)`,
  document_pendingtask:`Document's task is pending`,
};
export default global;
